import r from "./_nativeCreate.js";
var e = Object.prototype, o = e.hasOwnProperty;
function p(t) {
  var a = this.__data__;
  return r ? a[t] !== void 0 : o.call(a, t);
}
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_hashHas.js
// module id = 1477
// module chunks = 41